var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* ログインID変更 */
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import Block from '../molecules/Block';
import Text from '../molecules/Text';
import axios from '../axios';
import { Row, Col, Button } from 'react-bootstrap';
import { handleBrowzerBack } from '../BrowzerBack';
import LoadingModal from '../organisms/LoadingModal';
import { convertLine } from '../Convert';
import RowJustifyButton from '../molecules/RowJustifyButton';
import { jumpUrl } from '../Common';
import { http_status } from '../Const';
import RowCenterButton from '../molecules/RowCenterButton';
var LoginIdChange = function () {
    // ログインID情報のState
    // ログインID
    var _a = useState(''), login_id = _a[0], setLoginId = _a[1];
    // ログインID(確認)
    var _b = useState(''), login_id_confirmation = _b[0], setLoginIdConfirmation = _b[1];
    // ワンタイムパスワード
    var _c = useState(''), onetime_password = _c[0], setOneTimePassword = _c[1];
    // メールアドレスメッセージ
    var _d = useState([]), mail_address_message = _d[0], setMailAddressMessage = _d[1];
    // ワンタイムパスワードメッセージ
    var _e = useState([]), onetime_password_message = _e[0], setOneTimePasswordMessage = _e[1];
    var _f = useState(0), status_code = _f[0], setStatusCode = _f[1];
    // Ajax通信中フラグ
    var _g = useState(false), is_connecting = _g[0], setIsConnecting = _g[1];
    //ローディング画面表示状態
    var _h = useState(false), is_loading = _h[0], setIsLoading = _h[1];
    // 注意文言
    var _j = useState(''), attention_text = _j[0], setAttentionText = _j[1];
    // ワンタイムパスワード入力欄
    var _k = useState(false), show_one_time_password = _k[0], setShowOneTimePassword = _k[1];
    useEffect(function () {
        // ブラウザの戻る・進む禁止
        handleBrowzerBack();
        getAttentionText();
    }, []);
    /**
     * 注意文言を取得する
     */
    var getAttentionText = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    setIsLoading(true);
                    return [4 /*yield*/, axios.get('/login_id/attention_text')];
                case 1:
                    response = _a.sent();
                    setAttentionText(response.data.attention_text);
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _a.sent();
                    console.error;
                    return [3 /*break*/, 4];
                case 3:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    // メールアドレス変更ボタンのクリックイベントを定義
    var handleLoginIdChange = function () {
        // ログイン情報をStateへセット
        // 結果表示ボックスに適用するCSSクラス名
        var login_id_info = {
            login_id: login_id,
            login_id_confirmation: login_id_confirmation,
            onetime_password: onetime_password,
        };
        var loginIdChange = function () { return __awaiter(void 0, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        if (is_connecting) {
                            return [2 /*return*/];
                        }
                        //ローディング画面表示
                        setIsLoading(true);
                        setIsConnecting(true);
                        // 成功
                        return [4 /*yield*/, axios.post('/login_id/validate', login_id_info)];
                    case 1:
                        // 成功
                        _a.sent();
                        // ログインID変更完了画面へ遷移
                        location.replace(process.env.MIX_MOCK_URL + "/login_id/complete");
                        setIsConnecting(false);
                        return [3 /*break*/, 4];
                    case 2:
                        error_2 = _a.sent();
                        // 失敗
                        console.log(error_2.response.data.message);
                        jumpUrl(error_2.response.data.url);
                        setOneTimePasswordMessage(error_2.response.data.message);
                        setStatusCode(error_2.response.status);
                        setIsConnecting(false);
                        return [3 /*break*/, 4];
                    case 3:
                        // ローディング画面非表示
                        setIsLoading(false);
                        setMailAddressMessage([]);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        // ログインID変更処理
        loginIdChange();
    };
    // ワンタイムパスワード送信をクリック
    var handleSendOneTimePassword = function () {
        var login_id_info = {
            login_id: login_id,
            login_id_confirmation: login_id_confirmation,
        };
        var sendOnetimePassword = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        if (is_connecting) {
                            return [2 /*return*/];
                        }
                        //ローディング画面表示
                        setIsLoading(true);
                        setIsConnecting(true);
                        return [4 /*yield*/, axios.post("" + location.origin + process.env.MIX_MOCK_URL + "/login_id/send_onetime_passsword", login_id_info)];
                    case 1:
                        response = _a.sent();
                        setMailAddressMessage(response.data.message);
                        setStatusCode(response.status);
                        setShowOneTimePassword(true);
                        setTimeout(function () { return focusOneTimePassword(); }, 10);
                        return [3 /*break*/, 4];
                    case 2:
                        error_3 = _a.sent();
                        // 失敗
                        console.log(error_3.response.data.message);
                        setMailAddressMessage(error_3.response.data.message);
                        setStatusCode(error_3.response.status);
                        return [3 /*break*/, 4];
                    case 3:
                        setIsConnecting(false);
                        // ローディング画面非表示
                        setIsLoading(false);
                        setOneTimePasswordMessage([]);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        // ワンタイムパスワード発行
        sendOnetimePassword();
    };
    /**
     * 戻るボタンをクリックする
     */
    var handleClickReturn = function () {
        location.replace("" + location.origin + process.env.MIX_MOCK_URL + "/mypage/list");
    };
    /**
     * ワンタイムパスワードテキストボックスにフォーカス
     */
    var focusOneTimePassword = function () {
        var _a;
        (_a = document.getElementById('onetime-password')) === null || _a === void 0 ? void 0 : _a.focus();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "mt-5" }),
        React.createElement(Block, { label: "\u30ED\u30B0\u30A4\u30F3ID\u5909\u66F4", content: React.createElement(React.Fragment, null,
                React.createElement(Row, { className: "annotation newline" }, '新しいメールアドレスを入力してください。\n入力したメールアドレスにワンタイムパスワードを送信します。'),
                React.createElement("div", { className: "mt-3" }),
                React.createElement("div", null,
                    React.createElement(Text, { id: "email", label: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9", value: login_id, placeholder: "", handleChange: function (event) {
                            return setLoginId(event.target.value);
                        }, disabled: show_one_time_password, maxlength: 200 })),
                React.createElement("div", { className: "mt-3" },
                    React.createElement(Text, { id: "email-confirm", label: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\uFF08\u78BA\u8A8D\uFF09", value: login_id_confirmation, placeholder: "", handleChange: function (event) {
                            return setLoginIdConfirmation(event.target.value);
                        }, disabled: show_one_time_password, maxlength: 200 })),
                mail_address_message.length > 0 && (React.createElement(Row, { className: "d-flex align-items-center justify-content-center mt-3" },
                    React.createElement(Col, null),
                    React.createElement(Col, { md: 9, className: "pt-3 " + (status_code === http_status.ok ? 'alert-success' : 'alert-danger') + "\n                " },
                        React.createElement("ul", null, mail_address_message.map(function (mail_address_message, index) {
                            return React.createElement("li", { key: index }, mail_address_message);
                        }))))),
                React.createElement(Row, { className: "annotation mt-3", dangerouslySetInnerHTML: { __html: convertLine(attention_text) } }),
                React.createElement("div", { className: "mt-3" },
                    React.createElement(RowJustifyButton, null,
                        React.createElement("div", { className: "col col-lg-2" },
                            React.createElement(Button, { variant: "main-color", onClick: handleClickReturn, size: "lg", className: "lg mb-3" }, "\u623B\u308B")),
                        React.createElement("div", { className: "col-md-auto" }),
                        React.createElement("div", { className: "col col-lg-2" },
                            React.createElement(Button, { variant: "main-color", onClick: handleSendOneTimePassword, size: "lg", className: "lg" }, "\u30E1\u30FC\u30EB\u9001\u4FE1")))),
                show_one_time_password && (React.createElement("div", null,
                    React.createElement(Row, { className: "annotation newline mt-3" }, "\u30EF\u30F3\u30BF\u30A4\u30E0\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u767A\u884C\u3057\u307E\u3057\u305F\u3002\n\u30E1\u30FC\u30EB\u306B\u5C4A\u3044\u305F\u300C4\u6587\u5B57\u306E\u6570\u5B57\u300D\u3092\u5165\u529B\u3057\u3066\u3001\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306E\u5909\u66F4\u3092\u5B8C\u4E86\u3057\u3066\u304F\u3060\u3055\u3044\u3002"),
                    React.createElement("div", { className: "mt-3" },
                        React.createElement(Text, { id: "onetime-password", label: "\u30EF\u30F3\u30BF\u30A4\u30E0\u30D1\u30B9\u30EF\u30FC\u30C9", value: onetime_password, placeholder: "", handleChange: function (event) {
                                return setOneTimePassword(event.target.value);
                            }, disabled: false })),
                    React.createElement(Row, { className: "annotation newline mt-3" }, "\u30EF\u30F3\u30BF\u30A4\u30E0\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u6709\u52B9\u671F\u9650\u306F5\u5206\u3067\u3059\u3002\n\u30EF\u30F3\u30BF\u30A4\u30E0\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u5C4A\u304B\u306A\u3044\u5834\u5408\u3001\u623B\u308B\u306E\u30DC\u30BF\u30F3\u3092\u62BC\u3057\u3066\u6700\u521D\u304B\u3089\u64CD\u4F5C\u3057\u3066\u304F\u3060\u3055\u3044\u3002"),
                    React.createElement(RowCenterButton, null,
                        React.createElement(Button, { variant: "main-color", onClick: handleLoginIdChange, size: "lg", className: "lg  mb-3" }, "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u5909\u66F4")),
                    React.createElement("br", null))),
                onetime_password_message.length > 0 && (React.createElement(Row, { className: "d-flex align-items-center justify-content-center mt-3" },
                    React.createElement(Col, null),
                    React.createElement(Col, { md: 9, className: "pt-3 " + (status_code === http_status.ok ? 'alert-success' : 'alert-danger') + "\n                " },
                        React.createElement("ul", null, onetime_password_message.map(function (onetime_password_message, index) {
                            return React.createElement("li", { key: index }, onetime_password_message);
                        })))))) }),
        React.createElement(LoadingModal, { show: is_loading })));
};
if (document.getElementById('login-id-change')) {
    ReactDOM.render(React.createElement(LoginIdChange, null), document.getElementById('login-id-change'));
}
